<template>
  <div class="purchase-wrap">
    <el-card>
      <div slot="header" class="title">
        {{ $t('purchase::purchase-list::purchase-order-title') }}
      </div>
      <el-form inline :model="detailForm" :rules="addRules" ref="addForm" :label-position="'top'" label-width="120px">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('purchase::purchase-list::supplier')" prop="supplierId" style="width: 100%">
              <div style="display: flex">
                <el-select
                  :popperAppendToBody="false"
                  v-model="detailForm.supplierId"
                  @change="handleSelectSupplier"
                  style="flex: 1"
                >
                  <el-option
                    v-for="item in supplierList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <i class="el-icon-plus add-btn" @click="showAddSupplier = true" v-auth="'stores::supplier::add'"></i>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$t('purchase::purchase-list::plan_arrival_date')"
              prop="arrivalTime"
              style="width: 100%"
            >
              <el-date-picker
                :appendToBody="false"
                v-model="detailForm.arrivalTime"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 100%"
                :placeholder="$t('purchase::purchase-list::date_select')"
                :picker-options="pickerOptions"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('purchase::purchase-list::purchase_shipping')" prop="freight" style="width: 100%">
              <el-input
                v-model="detailForm.freight"
                :placeholder="$t('purchase::purchase-list::purchase_shipping')"
                @focus="focusSelect($event)"
              >
                <template slot="append">RMB</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item :label="$t('purchase::purchase-list::remark')" prop="remark" style="width: 100%">
              <el-input
                type="textarea"
                :rows="3"
                :placeholder="$t('purchase::purchase-list::input_holder')"
                v-model="detailForm.remark"
                maxlength="50"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card style="margin: 10px 0 48px">
      <div slot="header" class="title">
        {{ $t('purchase::purchase-list::purchase-goods-title') }}
      </div>
      <div class="row-style" v-show="!!detailForm.supplierId">
        <el-button type="primary" icon="el-icon-plus" @click="skuVisible = true" class="mb10">
          {{ $t('purchase::purchase-list::add_sku') }}
        </el-button>
        <el-radio-group v-model="priceType" class="mb10">
          <el-radio :label="1">{{ $t('purchase::purchase-list::price_input') }}</el-radio>
          <el-radio :label="2">{{ $t('purchase::purchase-list::total_input') }}</el-radio>
        </el-radio-group>
      </div>
      <z-table
        :columns="addColumns"
        :data="skuList"
        :customEmpty="true"
        :empty-text="$t('system::common::btn::no_data')"
        :pagination="false"
        :height="450"
      >
        <!-- <template #skuId="{ row }">
          <p>{{ row.skuId }}</p>
          <p>{{ row.optionValueNames }}</p>
        </template> -->
        <template #title="{ row }">
          <div class="sku-title">
            <ZImg :src="row.img" style="width: 65px; height: 65px"></ZImg>
            <div style="margin-left: 24px">
              <div class="one-line">{{ row.spuName }}</div>
              <p>SKU：{{ row.skuId }}</p>
              <p v-if="row.optionValueNames">{{ row.optionValueNames }}</p>
            </div>
          </div>
        </template>
        <template #skuPriceHeader>
          {{ $t('purchase::purchase-list::single_price') }}
          <el-tooltip class="item" effect="dark" placement="top-start">
            <div slot="content">
              {{ $t('purchase::purchase-list::price_equal') }}
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </template>
        <template #skuPrice="{ row }">
          <span v-if="priceType === 2">{{ row.skuPrice }}</span>
          <el-input-number
            style="width: 150px"
            v-model="row.skuPrice"
            :min="0"
            :precision="2"
            controls-position="right"
            @focus="focusSelect($event)"
            v-else
          ></el-input-number>
        </template>
        <template #quantity="{ row }">
          <el-input-number
            style="width: 150px"
            v-model="row.skuBuyQuantity"
            :min="1"
            controls-position="right"
            @focus="focusSelect($event)"
          ></el-input-number>
        </template>
        <template #skuTotal="{ row }">
          <span v-if="priceType === 1">{{ row.skuTotal }}</span>
          <el-input-number
            style="width: 150px"
            v-model="row.skuTotal"
            :min="0"
            :precision="2"
            controls-position="right"
            @focus="focusSelect($event)"
            v-else
          ></el-input-number>
        </template>
        <template #operate="{ row }">
          <!-- <el-popconfirm
            :title="$t('purchase::purchase-list::sku_delete_confirm')"
            @confirm="deleteSku(row)"
            :cancelButtonText="$t('system::common::btn::cancel')"
            :confirmButtonText="$t('system::common::btn::confirm')"
          >
          </el-popconfirm> -->
          <el-button type="text" style="color: #ff0022" @click="deleteSku(row)">删除</el-button>
        </template>
      </z-table>
      <p class="total-fee">{{ $t('purchase::purchase-list::total') }}：{{ totalFee }}</p>
    </el-card>
    <edit-dialog ref="edit" :isNew="true" v-model="showAddSupplier" @getListData="getSupplierList"></edit-dialog>
    <sku-dialog
      v-model="skuVisible"
      :skuList="skuList"
      :supplierId="detailForm.supplierId"
      @addSku="addSku"
    ></sku-dialog>
    <footer-fixed>
      <el-button size="small" @click="$router.back()">{{ $t('purchase::purchase-list::cancel') }}</el-button>
      <el-button class="mlr16" type="primary" size="small" @click="handleSave(2)" :loading="saveLoading">
        {{ $t('purchase::purchase-list::save_audit') }}
      </el-button>
      <el-button class="mlr16" type="primary" size="small" @click="handleSave(1)" :loading="saveLoading">
        {{ $t('purchase::purchase-list::save') }}
      </el-button>
    </footer-fixed>
  </div>
</template>

<script>
import EditDialog from '@/views/supplier/components/editDialog'
import SkuDialog from '@/views/purchase/components/skuDialog'
import { addRules, addColumns } from '../config'
import { getSupplierList } from '@/server/product'
import { addPurchaseOrder, getPurchaseDetail } from '@/server/purchase'
export default {
  name: 'purchase-list',
  components: { EditDialog, SkuDialog },
  data() {
    return {
      addRules,
      addColumns,
      showAddSupplier: false,
      detailForm: {
        supplierId: '',
        arrivalTime: '',
        freight: '0.00',
        remark: '',
      },
      supplierList: [],
      skuList: [],
      skuVisible: false,
      saveLoading: false,
      priceType: 1,
      id: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000
        },
      },
    }
  },
  created() {
    this.init()
    if (this.$route.params.id) {
      this.id = this.$route.params.id
      this.getDetail()
    }
  },
  methods: {
    async init() {
      const { data } = await getSupplierList({
        page_num: 1,
        status: 1,
        page_size: 100,
      })
      if (data.code === this.$code) {
        this.supplierList = (data.data && data.data.items) || []
      }
    },
    async getDetail() {
      const { data } = await getPurchaseDetail(this.$route.params.id)
      if (data.code === this.$code) {
        this.detailForm.supplierId = data.data.supplierId
        this.detailForm.arrivalTime = data.data.arrivalTime
        this.detailForm.freight = data.data.freight
        this.detailForm.remark = data.data.remark
        this.skuList = data.data.detail
      }
    },
    handleSelectSupplier(val) {
      this.supplierList.forEach(item => {
        if (item.id === val) {
          this.detailForm.supplier = item.name
        }
      })
      this.skuList = []
    },
    async getSupplierList() {},
    addSku(list) {
      this.skuList = list.map(item => ({
        ...item,
        skuBuyQuantity: 0,
        skuPrice: 0,
        skuTotal: 0,
      }))
    },
    handleSave(type) {
      if (this.skuList.length === 0) return this.$message.warning(this.$t('purchase::purchase-list::please_add_sku'))
      this.$refs.addForm.validate(async valid => {
        if (valid) {
          let params = {
            ...this.detailForm,
            freight: parseFloat(this.detailForm.freight),
            list: this.skuList.map(item => ({
              ...item,
              priceType: this.priceType,
            })),
            type,
          }
          if (this.id) params.id = this.id
          console.log(params)
          this.saveLoading = true
          const { data } = await addPurchaseOrder(params)
          this.saveLoading = false
          if (data.code === this.$code) {
            this.$message.success(this.$t('purchase::purchase-list::add_success'))
            this.$router.back()
          }
        }
      })
    },
    deleteSku(row) {
      this.$confirm(
        this.$t('purchase::purchase-list::sku_delete_confirm'),
        this.$t('purchase::purchase-list::dialog-tips'),
        {
          closeOnClickModal: false,
        }
      )
        .then(() => {
          this.skuList = this.skuList.filter(item => item.skuId !== row.skuId)
        })
        .catch(() => {})
    },
  },
  watch: {
    skuList: {
      handler(val) {
        this.skuList.forEach(item => {
          if (this.priceType === 1)
            item.skuTotal = isNaN(item.skuPrice * item.skuBuyQuantity) ? 0 : item.skuPrice * item.skuBuyQuantity
          else item.skuPrice = isNaN(item.skuTotal / item.skuBuyQuantity) ? 0 : item.skuTotal / item.skuBuyQuantity
        })
      },
      deep: true,
    },
  },
  computed: {
    totalFee() {
      let total = 0
      this.skuList.forEach(item => {
        total += Number(item.skuTotal)
      })
      total += parseFloat(this.detailForm.freight) || 0
      return total
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-table td {
    padding: 24px 0;
  }
  .el-card .el-card__header {
    border-bottom: 1px solid #dcdfe6;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-input-group__append {
    background-color: #f7f7f7 !important;
    border-color: #dddddd;
    color: #999999;
  }
  .el-select .el-input .el-select__caret {
    vertical-align: top;
  }
  .el-textarea .el-input__count {
    color: #999999;
  }
}
.iconadd {
  margin-left: 5px;
  font-size: 16px;
  color: #dcdfe6;
  cursor: pointer;
  line-height: 31px;
}
.total-fee {
  margin: 10px 0;
  font-size: 18px;
  font-weight: bold;
}
.row-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sku-title {
  display: flex;
  align-items: center;
  .one-line {
    max-width: 280px;
    font-weight: bold;
    color: #010517;
    margin-bottom: 5px;
  }
  p {
    font-size: 12px;
    color: #666666;
    line-height: 20px;
  }
}
.delete-icon {
  font-size: 22px;
  color: #f00;
  cursor: pointer;
}
.add-btn {
  font-size: 14px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  color: #010517;
  background: #f0f0f0;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  top: 0;
}
</style>
